import { render, staticRenderFns } from "./Nationality.vue?vue&type=template&id=41664419&"
import script from "./Nationality.vue?vue&type=script&lang=js&"
export * from "./Nationality.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports